/* 077 Shop-Filter: Kategorie, Marke, Plattform, Zustand, Preis, Verfuegbarkeit, Pruefung und Sortierung.
   Laedt den ganzen Bestand einmal als fertige Produktkarten (/collections/all?view=g077-grid),
   filtert und sortiert sofort im Browser und merkt sich den Stand in der Adresse (teilbar, Zurueck-Taste).
   Die Seite, auf der man ist (Kategorie, Marke, Plattform), wird nur vorausgewaehlt.
   Ohne JavaScript bleibt alles wie serverseitig gerendert (Raster, Seitenzahlen, Filterformular).
   Wird direkt hinter dem Shop-Block eingebunden (snippets/g077-shop.liquid), nicht verzoegert: Die Entscheidung
   „Filterleiste ja/nein“ (html.has-shop) faellt beim Einlesen der Seite, vor dem ersten Zeichnen; das Raster
   darunter wird erst nach dem Aufbau der Seite angefasst. */
(function () {
  'use strict';
  var root = document.querySelector('[data-shop]');
  if (!root || !window.fetch) return;
  var ready = function (fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); };

  var KAT = [['konsolen', 'Konsole', 'Konsolen'], ['handhelds', 'Handheld', 'Handhelds'], ['spiele', 'Spiel', 'Spiele'], ['zubehoer', 'Zubehör', 'Zubehör'], ['vr-brillen', 'VR-Brille', 'VR-Brillen']];
  var MARKEN = ['PlayStation', 'Xbox', 'Nintendo'];
  var PLAT_ORDER = ['PS5', 'PS4', 'PS3', 'PS2', 'PS1', 'PS Portal', 'PSP', 'PS Vita', 'Xbox Series', 'Xbox One', 'Xbox 360', 'Xbox', 'Switch 2', 'Switch', 'Wii U', 'Wii', 'GameCube', 'N64', '3DS', 'DS', 'Game Boy'];
  var ZUSTAND = [['Perfekt', 100], ['Gut', 75], ['Mittel', 50], ['Schlecht', 25]];
  /* Untergrenzen +0,01 €: ein Artikel fuer genau 10,00 € zaehlt nur in „bis 10 €“, nicht doppelt */
  var PREISE = [[0, 10, 'bis 10 €'], [10.01, 25, '10 – 25 €'], [25.01, 50, '25 – 50 €'], [50.01, 100, '50 – 100 €'], [100.01, null, 'über 100 €']];
  /* Kollektions-Handles und Tag-Pfade -> Vorauswahl */
  var PLAT_HANDLE = {'ps1': 'PS1', 'ps2': 'PS2', 'ps3': 'PS3', 'ps4': 'PS4', 'ps5': 'PS5', 'playstation-1': 'PS1', 'playstation-2': 'PS2', 'playstation-3': 'PS3', 'playstation-4': 'PS4', 'playstation-5': 'PS5', 'playstation-portal': 'PS Portal', 'xbox-one': 'Xbox One', 'xbox-one-s': 'Xbox One', 'xbox-classic': 'Xbox', 'xbox-360': 'Xbox 360', 'ds-3ds': ['3DS', 'DS'], 'nintendo-3ds': '3DS', 'nintendo-switch': 'Switch', 'switch': 'Switch', 'switch-2': 'Switch 2', 'nintendo-switch-2': 'Switch 2', 'xbox-series': 'Xbox Series', 'xbox-series-x': 'Xbox Series', 'psp': 'PSP', 'ps-vita': 'PS Vita', 'playstation-vita': 'PS Vita', 'ps-portal': 'PS Portal', 'wii': 'Wii', 'wii-u': 'Wii U', 'gamecube': 'GameCube', 'n64': 'N64', 'nintendo-64': 'N64', 'game-boy': 'Game Boy', 'gameboy': 'Game Boy', 'nintendo-ds': 'DS', 'ds': 'DS', '3ds': '3DS'};
  var PER = 24;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); };

  var section = root.closest('.section') || root.parentElement;
  var grid = null; /* erst nach dem Aufbau der Seite (steht im HTML hinter diesem Skript) */
  var drawer = document.getElementById('filter-drawer');
  if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer); /* nie in einem transformierten Eltern-Element */
  var groupsEl = $('[data-shop-groups]', drawer);

  /* ---------------------------------------------------------------- Zustand */
  var handle = root.dataset.handle || '';
  var preset = {kat: '', marke: [], plat: [], zustand: []};
  KAT.forEach(function (k) { if (handle === k[0]) preset.kat = k[0]; });
  MARKEN.forEach(function (m) {
    var h = m.toLowerCase();
    if (handle === h) preset.marke = [m];
    KAT.forEach(function (k) { if (handle === k[0] + '-' + h) { preset.kat = k[0]; preset.marke = [m]; } });
  });
  if (PLAT_HANDLE[handle]) preset.plat = [].concat(PLAT_HANDLE[handle]);
  (root.dataset.tags || '').split(',').forEach(function (t) {
    t = t.trim(); if (!t) return;
    [].concat(PLAT_HANDLE[t.toLowerCase().replace(/\s+/g, '-')] || []).forEach(function (p) { if (preset.plat.indexOf(p) < 0) preset.plat.push(p); });
    if (['Perfekt', 'Gut', 'Mittel', 'Schlecht'].indexOf(t) > -1 && preset.zustand.indexOf(t) < 0) preset.zustand.push(t);
    KAT.forEach(function (k) { if (k[1] === t) preset.kat = k[0]; });
    if (MARKEN.indexOf(t) > -1 && preset.marke.indexOf(t) < 0) preset.marke.push(t);
  });
  /* Fremde Kollektion (z. B. frontpage, sale): kein Filter-Umbau, das serverseitige Raster bleibt - entschieden nur am Handle,
     ein Tag in der Adresse (/collections/sale/ps2) darf die Kollektion nicht auf den ganzen Bestand aufreissen */
  var eigene = handle === 'all' || !!PLAT_HANDLE[handle] || MARKEN.some(function (m) { return handle === m.toLowerCase(); }) ||
    KAT.some(function (k) { return handle === k[0] || MARKEN.some(function (m) { return handle === k[0] + '-' + m.toLowerCase(); }); });
  if (handle && !eigene) return;

  var st = {kat: preset.kat, marke: preset.marke.slice(), plat: preset.plat.slice(), zustand: preset.zustand.slice(), min: null, max: null, verkauft: false, check: false, setup: false, sort: 'empfohlen'};
  var qs = new URLSearchParams(location.search);
  var list = function (v) { return v ? v.split(',').filter(Boolean) : []; };
  if (qs.has('kat') && (qs.get('kat') === '' || KAT.some(function (k) { return k[0] === qs.get('kat'); }))) st.kat = qs.get('kat');
  if (qs.has('marke')) st.marke = list(qs.get('marke'));
  if (qs.has('plattform')) st.plat = list(qs.get('plattform'));
  if (qs.has('zustand')) st.zustand = list(qs.get('zustand'));
  if (qs.has('preis')) { var pr = qs.get('preis').split('-'); st.min = pr[0] && isFinite(Number(pr[0])) ? Math.max(0, Number(pr[0])) : null; st.max = pr[1] && isFinite(Number(pr[1])) ? Math.max(0, Number(pr[1])) : null; }
  if (qs.get('verkauft') === '1') st.verkauft = true;
  if (qs.get('check') === '1') st.check = true;
  if (qs.get('setup') === '1') st.setup = true;
  if (qs.has('sort')) st.sort = qs.get('sort');
  /* Shopify-Sortierung aus der Adresse (sort_by=..., z. B. aus dem Formular ohne JavaScript) uebernehmen - eine Sortierung, ein Stand */
  var SHOPIFY_SORT = {'title-ascending': 'name-auf', 'title-descending': 'name-ab', 'price-ascending': 'preis-auf', 'price-descending': 'preis-ab', 'created-descending': 'neu', 'created-ascending': 'empfohlen', 'best-selling': 'empfohlen', 'manual': 'empfohlen'};
  if (!qs.has('sort') && qs.has('sort_by') && SHOPIFY_SORT[qs.get('sort_by')]) st.sort = SHOPIFY_SORT[qs.get('sort_by')];
  var shown = PER;

  function toUrl() {
    var u = new URLSearchParams();
    /* Fremde Parameter (utm_*, fbclid, ref …) bleiben in der Adresse, nur die eigenen werden neu gesetzt */
    var EIGENE = ['kat', 'marke', 'plattform', 'zustand', 'preis', 'verkauft', 'check', 'setup', 'sort', 'sort_by', 'page'];
    qs.forEach(function (v, k) { if (EIGENE.indexOf(k) < 0) u.set(k, v); });
    if (st.kat !== preset.kat) u.set('kat', st.kat);
    if (st.marke.join() !== preset.marke.join()) u.set('marke', st.marke.join(','));
    if (st.plat.join() !== preset.plat.join()) u.set('plattform', st.plat.join(','));
    if (st.zustand.join() !== preset.zustand.join()) u.set('zustand', st.zustand.join(','));
    if (st.min != null || st.max != null) u.set('preis', (st.min != null ? st.min : '') + '-' + (st.max != null ? st.max : ''));
    if (st.verkauft) u.set('verkauft', '1');
    if (st.check) u.set('check', '1');
    if (st.setup) u.set('setup', '1');
    if (st.sort !== 'empfohlen') u.set('sort', st.sort);
    var s = u.toString();
    history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  /* ---------------------------------------------------------------- Daten */
  var items = [];
  function parse(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    var ul = box.querySelector('ul[data-pages]');
    return {pages: Number(ul && ul.dataset.pages) || 1, lis: ul ? Array.prototype.slice.call(ul.children) : []};
  }
  function load() {
    var base = root.dataset.base.replace(/\/$/, '');
    var key = 'g077-grid-v1:' + base;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < 6e4) return Promise.resolve(c.h);
    } catch (e) { /* kein Cache */ }
    var t = Math.floor(Date.now() / 6e4);
    var get = function (n) {
      return fetch(base + '?view=g077-grid&page=' + n + '&t=' + t, {credentials: 'same-origin', cache: 'no-store'}).then(function (r) { if (!r.ok) throw new Error('grid'); return r.text(); });
    };
    return get(1).then(function (first) {
      var pages = Math.min(40, parse(first).pages), rest = [];
      for (var n = 2; n <= pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (more) {
        var all = [first].concat(more);
        try { sessionStorage.setItem(key, JSON.stringify({t: Date.now(), h: all})); } catch (e) { /* voll */ }
        return all;
      });
    });
  }
  function build(pages) {
    var i = 0;
    pages.forEach(function (h) {
      parse(h).lis.forEach(function (li) {
        var d = li.dataset;
        items.push({li: li, i: i++, plat: d.plat || 'Unbekannt', grade: d.grade, kat: d.kat, marke: d.marke, preis: Number(d.preis) || 0, frei: d.frei === '1', neu: Number(d.neu) || 0, titel: d.titel || '', check: d.check === '1'});
      });
    });
  }

  /* ---------------------------------------------------------------- Filtern */
  var katTag = function (k) { var x = KAT.filter(function (a) { return a[0] === k; })[0]; return x ? x[1] : ''; };
  function passt(it, ohne) {
    if (ohne !== 'frei' && !st.verkauft && !it.frei) return false;
    if (ohne !== 'kat' && st.kat && it.kat !== katTag(st.kat)) return false;
    if (ohne !== 'marke' && st.marke.length && st.marke.indexOf(it.marke) < 0) return false;
    if (ohne !== 'plat' && st.plat.length && st.plat.indexOf(it.plat) < 0) return false;
    if (ohne !== 'zustand' && st.zustand.length && st.zustand.indexOf(it.grade) < 0) return false;
    if (ohne !== 'preis' && st.min != null && it.preis < st.min * 100) return false;
    if (ohne !== 'preis' && st.max != null && it.preis > st.max * 100) return false;
    if (ohne !== 'check' && st.check && !it.check) return false;
    if (ohne !== 'setup' && st.setup && !passtSetup(it)) return false;
    return true;
  }
  /* „Passt zu meinem Setup“ (g077-plus.js: G077.setup / G077.fits) - nur Spiele und Zubehoer koennen passen */
  var G = window.G077 || {};
  var setupAktiv = function () { return typeof G.setup === 'function' && G.setup().length > 0; };
  var passtSetup = function (it) { if (typeof G.fits !== 'function') return false; var kind = it.kat === 'Spiel' ? 'game' : it.kat === 'Zubehör' ? 'accessory' : 'console'; return G.fits(it.plat, kind); };
  var rang = {Perfekt: 4, Gut: 3, Mittel: 2, Schlecht: 1};
  var coll = window.Intl && Intl.Collator ? new Intl.Collator('de') : {compare: function (a, b) { return a.localeCompare(b); }};
  function sortiert(l) {
    var f = {
      'neu': function (a, b) { return b.neu - a.neu || a.i - b.i; },
      'preis-auf': function (a, b) { return a.preis - b.preis || a.i - b.i; },
      'preis-ab': function (a, b) { return b.preis - a.preis || a.i - b.i; },
      'zustand': function (a, b) { return (rang[b.grade] || 0) - (rang[a.grade] || 0) || a.preis - b.preis; },
      'name-auf': function (a, b) { return coll.compare(a.titel, b.titel); },
      'name-ab': function (a, b) { return coll.compare(b.titel, a.titel); }
    }[st.sort];
    /* Verkaufte immer ans Ende */
    return l.slice().sort(function (a, b) { return (b.frei - a.frei) || (f ? f(a, b) : a.i - b.i); });
  }
  var zaehl = function (ohne, test) { var n = 0; items.forEach(function (it) { if (passt(it, ohne) && test(it)) n++; }); return n; };

  /* ---------------------------------------------------------------- Oberflaeche */
  var tabs = $('[data-shop-tabs]', root);
  var sortSel = $('[data-shop-sort]', root);
  var countEl = $('[data-shop-count]', root);
  var activeEl = $('[data-shop-active]', root);
  var nEl = $('[data-shop-n]', root);
  var showBtn = $('[data-shop-show]', drawer);
  var more = document.createElement('div');
  more.className = 'shop__more';

  function aktiveFilter() {
    var a = [];
    st.marke.forEach(function (m) { a.push(['marke', m, m]); });
    st.plat.forEach(function (p) { a.push(['plat', p, p]); });
    st.zustand.forEach(function (z) { a.push(['zustand', z, z]); });
    var pz = PREISE.filter(function (p) { return st.min === p[0] && st.max === p[1]; })[0];
    if (st.min != null || st.max != null) a.push(['preis', '', pz ? pz[2] : st.max == null ? 'ab ' + st.min + ' €' : (st.min || 0) + ' – ' + st.max + ' €']);
    if (st.check) a.push(['check', '', 'Nur ohne Hinweis']);
    if (st.setup) a.push(['setup', '', 'Passt zu meinem Setup']);
    if (st.verkauft) a.push(['verkauft', '', 'Mit Verkauften']);
    return a;
  }

  function row(type, name, value, label, n, on, extra) {
    var dis = !on && n === 0;
    return '<label class="shopf__row' + (dis ? ' is-empty' : '') + '"><input type="' + type + '" name="' + name + '" value="' + esc(value) + '"' + (on ? ' checked' : '') + (dis ? ' disabled' : '') + '><span class="shopf__mark" aria-hidden="true"></span><span class="shopf__label">' + esc(label) + '</span>' + (extra || '') + '<small>' + n + '</small></label>';
  }
  function gruppe(titel, inhalt, offen) {
    return '<details class="shopf__group"' + (offen ? ' open' : '') + '><summary><span>' + titel + '</span><i aria-hidden="true"></i></summary><div class="shopf__rows">' + inhalt + '</div></details>';
  }

  function zeichneGruppen() {
    var h = '';
    h += gruppe('Kategorie', row('radio', 'kat', '', 'Alle Kategorien', zaehl('kat', function () { return true; }), !st.kat) +
      KAT.map(function (k) { var n = zaehl('kat', function (it) { return it.kat === k[1]; }); return n || st.kat === k[0] ? row('radio', 'kat', k[0], k[2], n, st.kat === k[0]) : ''; }).join(''), true);
    h += gruppe('Marke', MARKEN.map(function (m) { var n = zaehl('marke', function (it) { return it.marke === m; }); return n || st.marke.indexOf(m) > -1 ? row('checkbox', 'marke', m, m, n, st.marke.indexOf(m) > -1) : ''; }).join(''), true);
    var plats = {};
    items.forEach(function (it) { plats[it.plat] = 1; });
    var pl = Object.keys(plats).sort(function (a, b) { var x = PLAT_ORDER.indexOf(a), y = PLAT_ORDER.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y) || a.localeCompare(b); });
    h += gruppe('Plattform', pl.map(function (p) { var n = zaehl('plat', function (it) { return it.plat === p; }); return n || st.plat.indexOf(p) > -1 ? row('checkbox', 'plat', p, p, n, st.plat.indexOf(p) > -1) : ''; }).join('') || '<p class="shopf__none">Keine passende Plattform.</p>', true);
    h += gruppe('Zustand', ZUSTAND.map(function (z) {
      var n = zaehl('zustand', function (it) { return it.grade === z[0]; });
      return row('checkbox', 'zustand', z[0], z[0], n, st.zustand.indexOf(z[0]) > -1, '<span class="shopf__bar" style="--lvl:' + z[1] + '%" aria-hidden="true"><b></b></span>');
    }).join(''), true);
    var aktivPreis = function (p) { return st.min === p[0] && st.max === p[1]; };
    h += gruppe('Preis', PREISE.map(function (p) {
      var n = zaehl('preis', function (it) { return it.preis >= p[0] * 100 && (p[1] == null || it.preis <= p[1] * 100); });
      return row('radio', 'preis', p[0] + '-' + (p[1] == null ? '' : p[1]), p[2], n, aktivPreis(p));
    }).join('') + '<div class="shopf__price"><label><span>von €</span><input type="number" inputmode="decimal" min="0" step="1" data-min value="' + (st.min != null && !PREISE.some(aktivPreis) ? st.min : '') + '" placeholder="0"></label><span aria-hidden="true">–</span><label><span>bis €</span><input type="number" inputmode="decimal" min="0" step="1" data-max value="' + (st.max != null && !PREISE.some(aktivPreis) ? st.max : '') + '" placeholder="beliebig"></label></div>', st.min != null || st.max != null);
    h += gruppe('Weitere', '<label class="shopf__switch"><input type="checkbox" name="check"' + (st.check ? ' checked' : '') + '><span class="shopf__label">Nur 077 CHECK ohne Hinweis<small>vollständig geprüft, keine Einschränkungen</small></span><i aria-hidden="true"></i></label>' +
      (setupAktiv() || st.setup ? '<label class="shopf__switch"><input type="checkbox" name="setup"' + (st.setup ? ' checked' : '') + (setupAktiv() ? '' : ' disabled') + '><span class="shopf__label">Passt zu meinem Setup<small>' + (setupAktiv() ? (function (n) { return n === 1 ? '1 Artikel (Spiel oder Zubehör) für: ' : n + ' Artikel (Spiele und Zubehör) für: '; })(zaehl('setup', passtSetup)) + esc(G.setup().join(', ')) : 'Konsolen unter „Mein Setup“ wählen') + '</small></span><i aria-hidden="true"></i></label>' : '') +
      '<label class="shopf__switch"><input type="checkbox" name="verkauft"' + (st.verkauft ? ' checked' : '') + '><span class="shopf__label">Verkaufte Artikel zeigen<small>zum Vergleichen, nicht mehr kaufbar</small></span><i aria-hidden="true"></i></label>', st.check || st.verkauft || st.setup);
    groupsEl.innerHTML = h;
  }

  function zeichneTabs() {
    var alle = zaehl('kat', function () { return true; });
    tabs.innerHTML = '<button type="button" data-kat=""' + (!st.kat ? ' aria-current="true"' : '') + '>Alle <small>' + alle + '</small></button>' +
      KAT.map(function (k) { var n = zaehl('kat', function (it) { return it.kat === k[1]; }); return n || st.kat === k[0] ? '<button type="button" data-kat="' + k[0] + '"' + (st.kat === k[0] ? ' aria-current="true"' : '') + '>' + k[2] + ' <small>' + n + '</small></button>' : ''; }).join('');
  }

  function titelSetzen(n) {
    var head = section.previousElementSibling && section.previousElementSibling.classList.contains('pagehead') ? section.previousElementSibling : null;
    if (!head) return;
    var h1 = $('h1', head), eb = $('.eyebrow', head);
    var k = KAT.filter(function (a) { return a[0] === st.kat; })[0];
    /* mehrere Plattformen/Marken (z. B. /collections/ds-3ds): „3DS und DS“ statt „Alle Artikel“ */
    var und = function (a) { return a.join(', ').replace(/, ([^,]*)$/, ' und $1'); };
    var wofuer = st.plat.length ? und(st.plat) : st.marke.length ? und(st.marke) : '';
    var titel;
    /* Duden-Kopplung „PS2-Spiele“; bei mehrteiligen Namen lesbarer als „Xbox-360-Spiele“: „Spiele für Xbox 360“ */
    if (!wofuer) titel = k ? k[2] : 'Alle Artikel';
    else if (!k) titel = 'Alles für ' + wofuer;
    else if (wofuer.indexOf(' ') < 0) titel = wofuer + '-' + k[2];
    else titel = k[2] + ' für ' + wofuer;
    if (h1) h1.textContent = titel;
    /* gleiche Wortwahl wie serverseitig: „… verfügbar“, solange Verkaufte nicht eingeblendet sind */
    if (eb) eb.textContent = n + (n === 1 ? ' Einzelstück' : ' Einzelstücke') + (st.verkauft ? '' : ' verfügbar');
  }

  function zeigen() {
    var treffer = sortiert(items.filter(function (it) { return passt(it); }));
    var frag = document.createDocumentFragment();
    treffer.slice(0, shown).forEach(function (it) { frag.appendChild(it.li); });
    grid.innerHTML = '';
    grid.appendChild(frag);
    /* Merkliste, Drop-Zaehler usw. an den neuen Karten nachziehen (g077-extra.js) */
    document.dispatchEvent(new CustomEvent('g077:grid', {detail: grid}));
    var rest = treffer.length - Math.min(shown, treffer.length);
    var naechste = Math.min(PER, rest);
    more.innerHTML = rest > 0 ? '<button class="btn btn--ghost" type="button" data-shop-more><span>' + (naechste === 1 ? '1 weiteren Artikel anzeigen' : naechste + ' weitere anzeigen') + ' <small>(' + rest + ' übrig)</small></span></button>' : '';
    if (!treffer.length) {
      grid.innerHTML = '<li class="shop__empty"><p class="empty__title">Nichts gefunden.</p><p>Mit diesen Filtern ist gerade kein Artikel da. Filter lockern oder einen Suchwunsch hinterlassen – wir melden uns, sobald etwas reinkommt.</p><p class="row"><button class="btn" type="button" data-shop-reset><span>Filter zurücksetzen</span></button></p></li>';
    }
    var n = treffer.length;
    countEl.innerHTML = '<b>' + n + '</b> Artikel' + (st.sort !== 'empfohlen' ? ' · ' + esc(sortSel.options[sortSel.selectedIndex].text) : '');
    showBtn.textContent = n === 1 ? '1 Artikel anzeigen' : n + ' Artikel anzeigen';
    var akt = aktiveFilter();
    var zahl = akt.length + (st.kat ? 1 : 0);
    nEl.hidden = !zahl; nEl.textContent = zahl;
    activeEl.innerHTML = akt.map(function (a) { return '<button type="button" class="chip shop__pill" data-weg="' + a[0] + '" data-wert="' + esc(a[1]) + '">' + esc(a[2]) + '<span aria-hidden="true">×</span><span class="visually-hidden"> entfernen</span></button>'; }).join('') +
      (akt.length ? '<button type="button" class="shop__clear" data-shop-reset>Alle entfernen</button>' : '');
    zeichneTabs();
    titelSetzen(n);
  }

  function fokus(el) { if (el && typeof el.focus === 'function') { try { el.focus({preventScroll: true}); } catch (_) { el.focus(); } } }

  function neu(offenHalten) {
    if (!items.length) return; /* Bestand noch nicht da: serverseitiges Raster nicht anfassen */
    shown = PER;
    toUrl();
    zeigen();
    if (!offenHalten) zeichneGruppen();
  }

  /* ---------------------------------------------------------------- Ereignisse */
  groupsEl.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'kat') st.kat = t.value;
    else if (t.name === 'marke' || t.name === 'plat' || t.name === 'zustand') {
      var arr = st[t.name];
      var i = arr.indexOf(t.value);
      if (t.checked && i < 0) arr.push(t.value);
      if (!t.checked && i > -1) arr.splice(i, 1);
    } else if (t.name === 'preis') { var p = t.value.split('-'); st.min = Number(p[0]); st.max = p[1] ? Number(p[1]) : null; }
    else if (t.matches('[data-min],[data-max]')) {
      var mi = $('[data-min]', groupsEl).value, ma = $('[data-max]', groupsEl).value;
      st.min = mi === '' ? null : Math.max(0, Number(mi)); st.max = ma === '' ? null : Math.max(0, Number(ma));
      if (st.min != null && st.max != null && st.min > st.max) { var x = st.min; st.min = st.max; st.max = x; }
    } else if (t.name === 'check') st.check = t.checked;
    else if (t.name === 'setup') st.setup = t.checked;
    else if (t.name === 'verkauft') st.verkauft = t.checked;
    /* Offene Abschnitte merken, Liste neu zeichnen (Zahlen aendern sich) */
    var offen = Array.prototype.map.call(groupsEl.querySelectorAll('details'), function (d) { return d.open; });
    var hatteFokus = document.activeElement === t;
    var sel = t.hasAttribute('data-min') ? '[data-min]' : t.hasAttribute('data-max') ? '[data-max]' : '[name="' + t.name + '"]' + (t.hasAttribute('value') ? '[value="' + String(t.value).replace(/["\\]/g, '\\$&') + '"]' : ''); /* Schalter ohne value-Attribut (check/setup/verkauft) */
    neu(t.matches('[data-min],[data-max]'));
    Array.prototype.forEach.call(groupsEl.querySelectorAll('details'), function (d, i) { if (offen[i] != null) d.open = offen[i]; });
    /* Tastatur: die neu gezeichnete Liste wuerde den Fokus verlieren und die Fokusfalle des Dialogs oeffnen */
    if (hatteFokus) fokus(groupsEl.querySelector(sel) || groupsEl.querySelector('input'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kat]');
    if (b && tabs.contains(b)) {
      var tabFokus = document.activeElement === b;
      st.kat = b.dataset.kat; neu();
      if (tabFokus) fokus(tabs.querySelector('[aria-current]') || tabs.querySelector('button'));
      return;
    }
    var w = e.target.closest('[data-weg]');
    if (w) {
      var k = w.dataset.weg, v = w.dataset.wert;
      var pillFokus = document.activeElement === w;
      if (k === 'preis') { st.min = null; st.max = null; } else if (k === 'check' || k === 'verkauft' || k === 'setup') st[k] = false; else st[k] = st[k].filter(function (x) { return x !== v; });
      neu();
      if (pillFokus) fokus(activeEl.querySelector('.shop__pill') || $('[data-open="filter"]', root) || $('[data-open="filter"]'));
      return;
    }
    if (e.target.closest('[data-shop-reset]')) {
      st.kat = ''; st.marke = []; st.plat = []; st.zustand = []; st.min = null; st.max = null; st.check = false; st.setup = false; st.verkauft = false;
      var inDrawer = drawer && drawer.contains(e.target);
      neu();
      /* der Knopf wurde gerade neu gezeichnet: Fokus sinnvoll weitergeben statt auf <body> zu fallen */
      fokus(inDrawer ? groupsEl.querySelector('input') : ($('[data-open="filter"]', root) || $('[data-open="filter"]')));
      return;
    }
    if (e.target.closest('[data-shop-more]')) {
      if (!items.length) return;
      var vorher = grid.children.length;
      shown += PER; zeigen();
      var erste = grid.children[vorher] && grid.children[vorher].querySelector('a[href]:not([tabindex="-1"])');
      fokus(erste);
    }
  });
  sortSel.addEventListener('change', function () { st.sort = sortSel.value; neu(true); });
  /* Mein Setup geaendert (g077-plus.js): Filtergruppe und Treffer nachziehen */
  document.addEventListener('g077:setup', function () { if (!items.length) return; if (st.setup && !setupAktiv()) st.setup = false; neu(); });

  /* Scrollposition und „mehr anzeigen“ ueber Zurueck-Taste und Neuladen hinweg merken (sessionStorage je Adresse) */
  var MERK = 'g077-shop:' + location.pathname + location.search;
  var merk = null;
  try { merk = JSON.parse(sessionStorage.getItem(MERK) || 'null'); } catch (e) { merk = null; }
  /* Neue Navigation (Link aus dem Menue auf dieselbe Adresse): oben anfangen, nur Zurueck-Taste und Neuladen holen den alten Stand */
  var navArt = ''; try { var navE = performance.getEntriesByType && performance.getEntriesByType('navigation')[0]; navArt = navE ? navE.type : ''; } catch (e) { navArt = ''; }
  if (navArt && navArt !== 'back_forward' && navArt !== 'reload') merk = null;
  if (merk && typeof merk.shown === 'number' && merk.shown > PER) shown = Math.min(merk.shown, 400);
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
  window.addEventListener('pagehide', function () {
    try { sessionStorage.setItem('g077-shop:' + location.pathname + location.search, JSON.stringify({shown: shown, y: window.scrollY})); } catch (e) {}
  });

  /* ---------------------------------------------------------------- Start */
  /* 1. sofort (beim Einlesen): Leiste gilt, Filterformular/Chips bleiben verborgen; Bestand schon laden */
  document.documentElement.classList.add('has-shop');
  sortSel.value = st.sort;
  if (sortSel.value !== st.sort) { st.sort = 'empfohlen'; sortSel.value = 'empfohlen'; }
  var laden = load();
  var abgebrochen = false;
  var abbruch = function () {
    if (abgebrochen) return; abgebrochen = true;
    /* Ohne Daten: serverseitiges Raster, Seitenzahlen und Filterformular bleiben stehen */
    document.documentElement.classList.remove('has-shop');
    root.removeAttribute('aria-busy');
    /* Scrollposition trotzdem zurueckholen (scrollRestoration steht schon auf „manual“) */
    if (merk && merk.y > 0 && !location.hash) { try { window.scrollTo(0, merk.y); } catch (e) { /* egal */ } }
  };
  laden.catch(abbruch);
  /* 2. nach dem Aufbau der Seite: Raster uebernehmen */
  ready(function () {
    grid = section.querySelector('ul.grid');
    if (!grid) {
      /* Seite ohne Artikel (z. B. leere Kollektion): leeres Raster anlegen, damit gefiltert werden kann */
      grid = document.createElement('ul');
      grid.className = 'grid';
      grid.setAttribute('role', 'list');
      root.insertAdjacentElement('afterend', grid);
    }
    grid.insertAdjacentElement('afterend', more);
    laden.then(function (pages) {
      build(pages);
      if (!items.length) throw new Error('leer');
      /* geteilter Link mit ?setup=1, aber hier kein Setup gewaehlt: Schalter aus statt „Nichts gefunden“ */
      if (st.setup && !setupAktiv()) st.setup = false;
      section.classList.add('is-shop');
      sortSel.disabled = false;
      root.removeAttribute('aria-busy');
      zeichneGruppen();
      zeigen();
      if (merk && merk.y > 0 && !location.hash) {
        var html = document.documentElement, sb = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, merk.y);
        html.style.scrollBehavior = sb;
      }
      merk = null;
    }).catch(abbruch);
  });
})();
